module.exports = __webpack_public_path__ + "static/media/icon_empty_state.d2423ae7.png";